import { JsonPipe } from '@angular/common';
import { Component, computed, Injector, input, OnInit, output, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { AppointmentPickerComponent } from '../../../../../../shared/components/appointment-picker/appointment-picker.component';
import { templateDrivenFormsViewProviders } from '../../../../../../shared/directives/form.directive';
import { ClaimStepConfig } from '../../../../types/claim-form.types';
import { AppointmentSlot, VisitAppointmentsData } from '../../../../types/visit-appointments.types';
import { ClaimsFormService } from '../../services/claims-form.service';

@Component({
  selector: 'app-visit-appointment',
  imports: [FormsModule, AppointmentPickerComponent, JsonPipe],
  templateUrl: './visit-appointment.component.html',
  styleUrl: './visit-appointment.component.scss',
  viewProviders: [templateDrivenFormsViewProviders],
})
export class VisitAppointmentComponent implements OnInit {
  formValue = input.required<Record<any, any>>();
  submittingValue = input.required<boolean>();
  formSubmitted = input.required<boolean>();
  activeStep = input.required<ClaimStepConfig>();
  stepConfig = input.required<Record<string, ClaimStepConfig> | undefined>();
  formValid = output<boolean>();
  loadingData = output<boolean>();

  valid = signal(false);
  loading = signal(false);

  validationMessage: string | undefined;

  private readonly viewModel = computed(() => {
    return {
      submittingValue: this.submittingValue(),
      formValue: this.formValue(),
      formSubmitted: this.formSubmitted(),
      formValid: this.valid(),
      activeStep: this.activeStep(),
      loading: this.loading(),
      hasBringForwardOption: !!this.stepConfig()?.['bring_forward'],
      bringForwardConfig: this.stepConfig()?.['bring_forward'],
    };
  });

  get vm() {
    return this.viewModel();
  }

  data: VisitAppointmentsData | undefined;

  slotValue: AppointmentSlot | undefined = undefined;

  constructor(
    private readonly injector: Injector,
    private readonly claimsFormService: ClaimsFormService
  ) {}

  ngOnInit(): void {
    this.validateForm();
    this.loadAppointments();
  }

  loadAppointments(): void {
    this.setLoadingDataState(true);
    this.claimsFormService.getVisitAppointments().subscribe({
      next: (val) => {
        this.setLoadingDataState(false);
        this.data = val;
      },
      error: (error) => {
        this.setLoadingDataState(false);
        console.log(error);
      },
    });
  }

  setLoadingDataState(state: boolean) {
    this.loading.set(state);
    this.loadingData.emit(state);
  }

  validateForm(): void {
    toObservable(this.formValue, { injector: this.injector }).subscribe({
      next: (formValue: any) => {
        const formValid = !!formValue?.[this.vm.activeStep.name];

        this.valid.set(formValid);
        this.formValid.emit(formValid);
      },
    });
  }
}
